import React from 'react';
import { Dictionary } from 'ts-essentials';

export type LoadingsTableContextValue = Dictionary<string>; // column flex sizes

export const LoadingsTableContext = React.createContext<LoadingsTableContextValue>({});

export const useLoadingsTableContext = () =>
  React.useContext(LoadingsTableContext);
